var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11C1 16.5022 5.49775 21 10.9998 21C16.5456 21 21.0434 16.5022 20.9997 11C20.9997 5.49782 16.5019 1 10.9998 1C5.49775 1 1 5.49782 1 11ZM2.09174 10.9563C2.09174 6.06549 6.06547 2.04802 10.9999 2.04802C15.9343 2.04802 19.908 6.06549 19.908 10.9563C19.908 15.8472 15.8906 19.8646 10.9999 19.8646C6.10914 19.8646 2.09174 15.8472 2.09174 10.9563Z",
    fill: "#2A85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 11H20.8497L20.8497 11.0012L20.9997 11ZM10.9998 20.85C5.58059 20.85 1.15 16.4193 1.15 11H0.85C0.85 16.585 5.4149 21.15 10.9998 21.15V20.85ZM20.8497 11.0012C20.8927 16.4189 16.4634 20.85 10.9998 20.85V21.15C16.6278 21.15 21.194 16.5854 21.1497 10.9988L20.8497 11.0012ZM10.9998 1.15C16.4191 1.15 20.8497 5.58066 20.8497 11H21.1497C21.1497 5.41498 16.5848 0.85 10.9998 0.85V1.15ZM1.15 11C1.15 5.58066 5.58059 1.15 10.9998 1.15V0.85C5.4149 0.85 0.85 5.41498 0.85 11H1.15ZM10.9999 1.89802C5.98215 1.89802 1.94174 5.98313 1.94174 10.9563H2.24174C2.24174 6.14785 6.1488 2.19802 10.9999 2.19802V1.89802ZM20.058 10.9563C20.058 5.98313 16.0176 1.89802 10.9999 1.89802V2.19802C15.851 2.19802 19.758 6.14785 19.758 10.9563H20.058ZM10.9999 20.0146C15.9735 20.0146 20.058 15.93 20.058 10.9563H19.758C19.758 15.7643 15.8078 19.7146 10.9999 19.7146V20.0146ZM1.94174 10.9563C1.94174 15.93 6.02629 20.0146 10.9999 20.0146V19.7146C6.19198 19.7146 2.24174 15.7643 2.24174 10.9563H1.94174Z",
    fill: "#2A85FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2962 16.2943L10.4116 12.5443V5.70605H11.3279V12.059L13.941 15.4561L13.2962 16.2943Z",
    fill: "#2A85FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2962 16.2943L10.4116 12.5443V5.70605H11.3279V12.059L13.941 15.4561L13.2962 16.2943",
    stroke: "#2A85FF",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f9ccd62381fc009c69b463cea0c4ad61.svg";
export { ForwardRef as ReactComponent };